import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/dafb09htto0ceqqnh9c0";

export default function Subscribe() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");
  const [formError, setFormError] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("idle");
    setMessage("");
    setFormError("");

    const form = e.currentTarget;
    const fd = new FormData(form);

    // 蜜罐检测：命中则静默给出成功反馈，不发请求
    const hp = String(fd.get("company_alt") || "").trim();
    if (hp !== "") {
      setStatus("success");
      setMessage("感谢订阅，今日份糖分已送达，请留意你的邮箱～");
      form.reset();
      return;
    }

    const email = String(fd.get("email") || "");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setStatus("error");
      setFormError("请输入有效的邮箱地址哦。");
      return;
    }

    const payload = new URLSearchParams();
    const emailVal = fd.get("email");
    if (emailVal) payload.append("email", String(emailVal));

    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.detail || parsed?.meta?.message || parsed?.message || responseText || "";
      const isSpam = /spam|form data is spam/i.test(serverMsg);

      if (!res.ok || !parsed || parsed.code !== "OK" || isSpam) {
        setStatus("error");
        setFormError(serverMsg && serverMsg.trim() ? serverMsg : "订阅失败了，请稍后再试。");
        return;
      }
      setStatus("success");
      setMessage("订阅成功！你已加入糖分补给站，甜料第一时间送达。");
      form.reset();
    } catch {
      setStatus("error");
      setFormError("网络开小差了，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-primary-500 via-primary-400 to-accent-400 px-6 py-12 md:px-12 md:py-16">
          <div className="pointer-events-none absolute -right-8 -top-10 h-52 w-52 rounded-full bg-white/10 blur-2xl"></div>
          <div className="pointer-events-none absolute -bottom-12 left-10 h-40 w-40 rounded-full bg-accent-300/20 blur-2xl"></div>

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <h2 className="font-display text-3xl leading-snug text-white md:text-5xl">把每日糖分装进邮箱</h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-white/85 md:text-base">
                订阅吃瓜糖心，第一时间收到高甜瓜料、甜蜜精选与治愈故事推送，让每一个平凡日子都甜一点。
              </p>
            </div>

            <form onSubmit={handleSubmit} data-readdy-form="吃瓜糖心邮件订阅" className="lg:justify-self-end lg:w-full lg:max-w-md">
              <div className="rounded-2xl bg-white/95 p-4 shadow-none">
                <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:rounded-full sm:bg-background-100 sm:p-1.5">
                  <div className="flex flex-1 items-center gap-2 rounded-full bg-background-100 px-4 py-3 sm:bg-transparent sm:py-2">
                    <i className="ri-mail-line text-lg text-secondary-500"></i>
                    <input
                      type="email"
                      name="email"
                      placeholder="输入你的邮箱，接收今日糖分"
                      className="w-full bg-transparent text-sm outline-none placeholder:text-foreground-400"
                    />
                  </div>
                  <button
                    type="submit"
                    className="whitespace-nowrap cursor-pointer rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-primary-600"
                  >
                    立即订阅
                  </button>
                </div>

                {/* 蜜罐字段 */}
                <input
                  type="text"
                  name="company_alt"
                  className="hp-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />

                <p className="mt-2 px-2 text-xs text-foreground-500">不发送垃圾邮件，随时可退订。</p>

                {status === "success" && (
                  <p className="mt-3 flex items-start gap-2 rounded-lg bg-accent-100 px-3 py-2 text-sm text-accent-800">
                    <i className="ri-checkbox-circle-fill mt-0.5"></i>
                    {message}
                  </p>
                )}
                {status === "error" && formError && (
                  <p className="mt-3 flex items-start gap-2 rounded-lg bg-primary-100 px-3 py-2 text-sm text-primary-800">
                    <i className="ri-error-warning-fill mt-0.5"></i>
                    {formError}
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}